import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@assets/images/activity/loading.png';
const _withScopeId = n => (_pushScopeId("data-v-2a3cceda"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "img-box"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0
})], -1));
const _hoisted_2 = {
  class: "swipe-box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createBlock(_component_van_popup, {
    show: $options.show
  }, {
    default: _withCtx(() => [_createElementVNode("div", {
      class: "loading-box",
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
    }, [_hoisted_1, _createElementVNode("div", _hoisted_2, " 你的藏品正在合成中喔......" + _toDisplayString($props.loading_time) + "% ", 1)])]),
    _: 1
  }, 8, ["show"]);
}